
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import moment from 'moment';

moment.locale('it');

@Component
export default class WeekPickerDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  // La data da visualizzare (nel formato YYYY-MM-DD)
  @Prop({ type: String, default: null }) readonly date!: string | null;

  // Se true, permette la selezione di una data
  @Prop({ type: Boolean, default: false }) readonly allowSingle!: boolean;

  // Se true, permette la selezione di una settimana
  @Prop({ type: Boolean, default: true }) readonly allowWeek!: boolean;

  // La modalità di selezione iniziale
  @Prop({ type: String, default: 'week' }) readonly initialMode!: 'single' | 'week';

  mode: 'single' | 'week' = 'week'

  newValue: string | null = null
  newTextValue: string | null = null

  dialog = false

  @Watch('value')
  onValueChange(val: boolean) {
    this.dialog = val;

    // Se il dialog è stato aperto...
    if (val === true) {
      // Imposta il tipo di selezione iniziale
      this.mode = this.initialMode;

      // ... imposta la data iniziale da visualizzare
      this.newValue = this.date
        ? moment(this.date).toISOString(true).substring(0, 10)
        : null;

      if (this.mode === 'single') {
        // Selezione di una data singola

        // ... imposta il valore del campo di testo nel formato DD/MM/YYYY
        this.newTextValue = this.newValue
          ? moment(this.newValue, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : null;
      } else {
        // Selezione di una settimana

        // ... imposta il valore del campo di testo nel formato WW-GGGG
        this.newTextValue = this.newValue
          ? moment(this.newValue, 'YYYY-MM-DD').format('WW-GGGG')
          : null;
      }
    }
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  // Converte una settimana nel formato WW-GGGG in un Date
  weekToDate(val: string): Date | null{
    console.log(`${this.constructor.name}: weekToDate() val =`, val); // eslint-disable-line no-console

    if (!val) return null;

    // Se non è nel formato WW-GGGG, la data non è valida
    if (!val.match(/^\d{2}-\d{4}$/)) return null;

    const year = parseInt(val.substring(3, 7), 10); // 2025
    const week = parseInt(val.substring(0, 2), 10); // 01

    console.log(`${this.constructor.name}: weekToDate() year =`, year); // eslint-disable-line no-console
    console.log(`${this.constructor.name}: weekToDate() week =`, week); // eslint-disable-line no-console

    if (Number.isNaN(year) || Number.isNaN(week)) return null;
    if (week < 1 || week > 53) return null;

    // Converti la settimana specificata da `${year}-W${week}` rispettando il formato ISO 8601
    // in una data di tipo Date
    const date = moment(val, 'WW-GGGG').toDate();

    console.log(`${this.constructor.name}: weekToDate() date =`, date); // eslint-disable-line no-console

    return date;
  }

  // Rivela le modifiche a `mode`
  @Watch('mode')
  onMode(val: 'single' | 'week') {
    console.log(`${this.constructor.name}: onMode() val =`, val); // eslint-disable-line no-console

    console.log(`${this.constructor.name}: onMode() this.newValue =`, this.newValue); // eslint-disable-line no-console

    if (val === 'single') {
      // Selezione di una data singola

      // Imposta il valore del campo di testo nel formato DD/MM/YYYY
      this.newTextValue = this.newValue
        ? moment(this.newValue, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : null;
    } else {
      // Selezione di una settimana

      // Imposta il valore del campo di testo nel formato WW-GGGG
      this.newTextValue = this.newValue
        ? moment(this.newValue, 'YYYY-MM-DD').format('WW-GGGG')
        : null;
    }
  }

  // Rileva la modifica del valore del campo di testo
  @Watch('newTextValue')
  onNewTextValue(val: string | null) {
    console.log(`${this.constructor.name}: onNewTextValue() val =`, val); // eslint-disable-line no-console

    if (this.mode === 'single') {
      // Selezione di una data singola

      // Trasforma in un valore di tipo Date prima di restituirlo
      const newValue = val
        ? moment(val, 'DD/MM/YYYY', true).toDate()
        : null;
      console.log(`${this.constructor.name}: onNewTextValue() newValue =`, newValue); // eslint-disable-line no-console

      // Se è una data valida, la memorizza in this.newValue nel formato corretto
      if (newValue && moment(newValue).isValid()) {
        this.newValue = moment(newValue).format('YYYY-MM-DD');
      } else if (newValue === null) {
        // Se è null, la memorizza in this.newValue (data cancellata)
        this.newValue = null;
      }
    } else {
      // Selezione di una settimana

      // Trasforma in un valore di tipo Date prima di restituirlo
      const textValue = val
        ? this.weekToDate(val)
        : null;

      console.log(`${this.constructor.name}: onNewTextValue() textValue =`, textValue); // eslint-disable-line no-console

      console.log(`${this.constructor.name}: onNewTextValue() moment(textValue).isValid() =`, moment(textValue).isValid()); // eslint-disable-line no-console

      // Se la data è valida...
      if (textValue && moment(textValue).isValid()) {
        // Verifica se la settimana corrispondente è diversa dalla settimana corrispondente attualmente selezionata
        const newWeek = moment(textValue).format('WW-GGGG');
        const currentWeek = this.newValue
          ? moment(this.newValue, 'YYYY-MM-DD').format('WW-GGGG')
          : null;

        console.log(`${this.constructor.name}: onNewTextValue() newWeek =`, newWeek); // eslint-disable-line no-console
        console.log(`${this.constructor.name}: onNewTextValue() currentWeek =`, currentWeek); // eslint-disable-line no-console

        // Se la settimana è diversa, la memorizza in this.newValue nel formato corretto
        if (newWeek !== currentWeek) {
          this.newValue = moment(textValue).format('YYYY-MM-DD');
        }
      } else if (textValue === null) {
        // Se è null, la memorizza in this.newValue (data cancellata)
        this.newValue = null;
      }
    }
  }

  // Rileva la modifica del valore del datepicker
  @Watch('newValue')
  onNewValue(val: string | null) {
    console.log(`${this.constructor.name}: onNewValue() val =`, val); // eslint-disable-line no-console

    if (this.mode === 'single') {
      // Selezione di una data singola

      // Trasforma in un valore di tipo Date prima di restituirlo
      const newValue = val
        ? moment(val, 'YYYY-MM-DD').toDate()
        : null;

      // Se è una data valida, la memorizza in this.newTextValue nel formato corretto
      if (newValue && moment(newValue).isValid()) {
        const newTextValue = moment(newValue).format('DD/MM/YYYY');
        if (this.newTextValue !== newTextValue) {
          this.newTextValue = newTextValue;
        }
      } else if (newValue === null) {
        // Se è null, la memorizza in this.newTextValue (data cancellata)
        if (this.newTextValue !== null) {
          this.newTextValue = null;
        }
      }
    } else {
      // Selezione di una settimana

      // Trasforma la data selezionata in un valore di tipo Date
      const newValueDate = val
        ? moment(val, 'YYYY-MM-DD').toDate()
        : null;
      console.log(`${this.constructor.name}: onNewValue() newValueDate =`, newValueDate); // eslint-disable-line no-console

      // Trasforma la data selezionata in un valore di tipo WW-GGGG
      const newValueWeek = newValueDate && moment(newValueDate).isValid()
        ? moment(newValueDate).format('WW-GGGG')
        : null;
      console.log(`${this.constructor.name}: onNewValue() newValueWeek =`, newValueWeek); // eslint-disable-line no-console

      // Se è null, la memorizza in this.newTextValue (data cancellata)
      if (newValueWeek === null) {
        this.newTextValue = null;
        console.log(`${this.constructor.name}: onNewValue() this.newTextValue = null`); // eslint-disable-line no-console
      }

      // Se la nuova settimana è diversa da quella precedente, la memorizza in this.newTextValue
      if (this.newTextValue !== newValueWeek) {
        console.log(`${this.constructor.name}: onNewValue() newValueWeek diverso dal precedente (${this.newTextValue})`); // eslint-disable-line no-console

        this.newTextValue = newValueWeek;
      }
    }
  }

  // Controlla se la data è valida
  isDateValid(val: string | null) {
    // Se è null, la data è valida
    if (val === null) return true;

    // Controlla se la data è valida
    const date = moment(val, 'DD/MM/YYYY', true).toDate();
    return moment(date).isValid();
  }

  // Controlla se la data è valida
  isWeekValid(val: string | null) {
    // Se è null, la data è valida
    if (val === null) return true;

    // Se non è nel formato WW-GGGG, la data non è valida
    if (!val.match(/^\d{2}-\d{4}$/)) return false;

    // Estrae anno e numero della settimana da `val` che è nel formato WW-GGGG
    const year = parseInt(val.substring(3, 7), 10);
    const week = parseInt(val.substring(0, 2), 10);

    if (Number.isNaN(year) || Number.isNaN(week)) return false;
    if (week < 1 || week > 53) return false;

    const date = moment(val, 'WW-GGGG').toDate();

    return moment(date).isValid();
  }

  // È stata selezionata una data
  async onSelect() {
    console.log(`${this.constructor.name}: onSelect() newValue =`, this.newValue); // eslint-disable-line no-console

    this.$emit('select', this.newValue, this.mode);
  }
}
